<template>
  <div>
    <main-header/>
    <div class="currentBag-bg">
      <nav-bar class="d-md-block d-none"/>
      <div class="container">
        <div class="registerUser-bg">
          <div class="font-weight-bold font-16">
            ثبت نام
          </div>
          <div>لطفا موارد زیر را تکمیل کنید:</div>
          <div class="row">
            <div class="col-12">
              <div class="mt-5">
                <div class="font-weight-bold font-16">موبایل</div>
                <v-text-field
                    v-model="mobile"
                    :rules="phoneNumberRules"
                    class="mt-2"
                    label="بدین شکل وارد کنید: 09121234567"
                    single-line
                    solo
                ></v-text-field>
              </div>
              <div class="mt-5">
                شما بایستی موبایل وارد شده را فعال کنید جهت انجام این مهم روی دکمه زیر کلیک کنید و کد
                فعال
                سازی که پیامک می شود را در محل مربوطه وارد کنید :
              </div>
              <v-btn
                  :disabled="mobile === null "
                  block
                  class="mt-2"
                  color="secondary"
                  @click="sendVerifyMobile()">
                درخواست کد فعال سازی موبایل
              </v-btn>
              <v-text-field
                  v-model="activationCode"
                  class="mt-5"
                  hide-details
                  label="کد فعال سازی را اینجا وارد کنید"
                  single-line
                  solo

              ></v-text-field>
              <v-btn
                  :disabled="activationCode === null"
                  block
                  class="mt-8"
                  color="secondary"
                  @click="registerUser()">
                ایجاد حساب کاربری
              </v-btn>

            </div>
          </div>
        </div>
      </div>

      <Footer/>
      <navigation-drawer :drawer="drawer"/>
      <v-dialog
          v-model="showLoaderDialog"
          hide-overlay
          persistent
          width="500">
        <v-card class="text-center py-5">
          <v-progress-circular
              color="primary"
              indeterminate
          ></v-progress-circular>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showResultDialog"
          persistent
          width="500">
        <v-card class="text-center pt-5">
          <v-card-text class="pb-0">
            <div class="mb-0 black--text">{{ dialogResult }}</div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pt-1 pb-3">
            <v-btn block class="primary" rounded @click="hideDialogResult()">
              بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
let _this = null
import MainHeader from "./mainHeader";
import NavBar from "./navBar";
import Footer from "./Footer";
import NavigationDrawer from "./navigationDrawer";

export default {
  name: "registerUser",
  components: {NavigationDrawer, Footer, NavBar, MainHeader},
  data: () => ({
    drawer: false,
    showLoaderDialog: false,
    showResultDialog: false,
    dialogResult: null,
    mobile: null,
    activationCode: null,
    phoneNumberRules: [
      value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
  }),
  mounted() {
    _this = this

  },
  methods: {
    silentLogin() {

      let myHeaders = new Headers();
      let formdata = new FormData();


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      let loggedInUserData = this.$getUserData();

      formdata.append("PhoneNumber", loggedInUserData.mobile);
      formdata.append("Password", loggedInUserData.activeCode);


      fetch(this.$baseUrl + "/Home/Login", requestOptions)
          .then(response => {
            console.log('1', response);
            console.log(response.Result);
            console.log(response.status);

            if (response.status === 200) {
              return response.text();
            }
          })
          .then(result => {
            let jsonResponse = JSON.parse(result);
            if (jsonResponse) {
              let token = 'Bearer ' + jsonResponse.JwtToken
              _this.$setUserData(loggedInUserData.mobile, loggedInUserData.activeCode, token);
              _this.isLoggedIn = true;
            }

          })
          .catch(error => {
            (console.log('errorsilent', error))
          });

    },
    sendVerifyMobile() {
      _this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("PhoneNumber", this.mobile);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Home/RequestVerfiyMobile", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;
            _this.showResultDialog = true;
            _this.dialogResult = result
            console.log(result)

          })
          .catch(error => {
            console.log('error', error)
          });
    },
    registerUser() {
      _this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("PhoneNumber", this.mobile);
      urlencoded.append("VeriyMobileCode", this.activationCode);
      urlencoded.append("IsActive", "true");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Home/RegisterUser", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;
            _this.showResultDialog = true;
            _this.dialogResult = result
            _this.hideDialogResult();
            _this.$setUserData(this.mobile, this.activationCode);
            _this.silentLogin();
            _this.$router.replace({path: "Home"});
          })
          .catch(error => {
            _this.showLoaderDialog = false;
            _this.dialogResult = 'کد وارد شده اشتباه است.';
            _this.showResultDialog = true
            console.log('error', error)
          });
    },
    hideDialogResult() {
      this.showResultDialog = !this.showResultDialog;
    }
  }
}
</script>

<style scoped>

</style>
